import InputMobile from "common/components/InputMobile";
import React from "react";
import PersonalInformationIcon1 from "assets/images/PersonalInformationTab-icon1.png";
import PersonalInformationIcon2 from "assets/images/PersonalInformationTab-icon2.png";
import Button from "common/components/Button";
import PasswordInput from "common/components/PasswordInput/PasswordInput";
import { Controller } from "react-hook-form";
import { useTypedSelector } from "store";

interface Props {
  controlUser: any;
  onChangeNumber?: (e: any, val: any) => void;
  errorsUser?: any;
  handleSubmit: any;
  handleSubmitUser: any;
  onChangeUser: any;
  onChangePassword: any;
  control: any;
  errors: any;
}

const PersonalInformationMobileTab = ({
  controlUser,
  onChangeNumber,
  onChangeUser,
  handleSubmitUser,
  onChangePassword,
  errors,
  control,
  handleSubmit
}: Props) => {
  const { client } = useTypedSelector((store) => store.user);

  return (
    <div className="personalInformationTab-form-main-mobile">
      <div className="personalInformationTab-label-block" style={{ paddingTop: 16 }}>
        <div className="PersonalInfo-icon-otr">
          <img className="PersonalInfo-icon" src={PersonalInformationIcon1} alt="icon" />
        </div>
        <h3>פרטים אישיים</h3>
      </div>
      <div
        className="personalInformationTab-form"
        style={{ marginTop: 10, gap: 10, display: "flex", flexDirection: "column" }}>
        <Controller
          name="name"
          control={controlUser}
          rules={{ required: true }}
          render={({ field }) => {
            return (
              <div className="PersonalInfo-Input-otr">
                <InputMobile placeholder="שם מלא" {...field} disabled />
              </div>
            );
          }}
        />
        <InputMobile placeholder="דוא”ל" value={client.email} disabled />
        <Controller
          name="phone"
          control={controlUser}
          rules={{ required: true }}
          render={({ field }) => {
            return (
              <InputMobile
                placeholder="מספר נייד"
                {...field}
                type="number"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                onChange={(e) => onChangeNumber && onChangeNumber(e, field)}
                style={{ direction: "rtl" }}
                maxLength={10}
              />
            );
          }}
        />
        <Button text="שמירת שינויים" typeBtn="red" onClick={handleSubmitUser(onChangeUser)} />
      </div>
      <div className="personalInformationTab-label-block" style={{ marginTop: 30 }}>
        <div className="PersonalInfo-icon-otr">
          <img className="PersonalInfo-icon" src={PersonalInformationIcon2} alt="icon" />
        </div>
        <h3>שינוי סיסמה</h3>
      </div>
      <div
        className="personalInformationTab-form"
        style={{ marginTop: 10, gap: 10, display: "flex", flexDirection: "column" }}>
        <Controller
          name="password"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="PersonalInfo-Input-otr">
              <PasswordInput
                placeholder="סיסמה נוכחית"
                className={`${errors.password ? "invalid-input" : ""}`}
                {...field}
              />
              {errors.password && (
                <span className="validation-text">{errors?.password.message || ""}</span>
              )}
            </div>
          )}
        />
        <Controller
          name="newPass"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="PersonalInfo-Input-otr">
              <PasswordInput
                placeholder="סיסמה חדשה"
                className={`${errors.password ? "invalid-input" : ""}`}
                {...field}
              />
              {errors.newPass && (
                <span className="validation-text">{errors?.newPass.message || ""}</span>
              )}
            </div>
          )}
        />
        <Controller
          name="repeatPass"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <div className="PersonalInfo-Input-otr">
              <PasswordInput
                placeholder="אימות סיסמה חדשה"
                className={`${errors.repeatPass ? "invalid-input" : ""}`}
                {...field}
              />
              {errors.repeatPass && (
                <span className="validation-text">{errors?.repeatPass.message || ""}</span>
              )}
            </div>
          )}
        />

        <Button text="שמירת שינויים" typeBtn="red" onClick={handleSubmit(onChangePassword)} />
      </div>
    </div>
  );
};

export default PersonalInformationMobileTab;
